export default {
  "introductionCorporate.specialMembers.b-p-and-r-m":
    "バイオ・医薬品・再生医療等",
  "introductionCorporate.specialMembers.consulting-and-support-organizations":
    "コンサルティング・事業化支援",
  "introductionCorporate.specialMembers.education-and-research": "教育・研究",
  "introductionCorporate.specialMembers.healthcare-services":
    "医療IT・サービス",
  "introductionCorporate.specialMembers.medical-and-welfare": "医療・福祉",
  "introductionCorporate.specialMembers.medical-devices-and-testing-equipment":
    "医療機器・検査機器等",
  "introductionCorporate.specialMembers.non-profit-organizations": "非営利団体",
  "introductionCorporate.specialMembers.others": "その他",
  "introductionCorporate.specialMembers.patent-and-law": "知財・法律",
  "introductionCorporate.specialMembers.private-companies": "企業",
  "introductionCorporate.specialMembers.public-agencies": "公的機関",
  "introductionCorporate.specialMembers.society": "学会",
  "introductionCorporate.specialMembers.special-members": "特別会員一覧",
  "introductionCorporate.specialMembers.universities": "大学",
  "introductionCorporate.specialMembers.vcs": "VC",
  "introductionCorporate.specialMembers.tenant": "テナント",

  "introductionCorporate.specialMembers.title":
    "特別会員企業 / テナント企業一覧 | LINK-J",
  "introductionCorporate.specialMembers.description":
    "LINK-J特別会員に登録されている法人・団体組織の一覧",
  "introductionCorporate.specialMembers.ogSiteName": "LINK-J",
  "introductionCorporate.specialMembers.ogDescription":
    "LINK-J特別会員に登録されている法人・団体組織の一覧",
  "introductionCorporate.specialMembers.ogTitle":
    "特別会員企業 / テナント企業一覧 | LINK-J",

  "introductionCorporate.specialMembers.itemTitle": "特別会員一覧",
  "introductionCorporate.specialMembers.headingPage": "特別会員一覧",
  "introductionCorporate.specialMembers.tenantTag": "テナント",
  "introductionCorporate.specialMembers.aboutTenant1":
    "※ 掲載可能な特別会員A、B の企業・団体様について掲載しております。",
  "introductionCorporate.specialMembers.aboutTenant2":
    "※ 「テナント」について、",
  "introductionCorporate.specialMembers.aboutTenant3":
    "ライフサイエンスビルシリーズ",
  "introductionCorporate.specialMembers.aboutTenant4":
    "に加え、日本橋一丁目ビルディング、日本橋本町YSビル、室町東三井ビルディング等を含む。",
} as const;
